import React, { useCallback } from 'react';

import { GROUP_OPTIONS } from '../modals/chartCreationConstants';
import { CHART_COLORS } from './constants';
import AvatarTick from './ticks/AvatarTick';
import { formatLabel } from './utils';

const CustomTick = ({ labelEntities, labelType, payload, x, y, dx, dy }) => {
  const renderLabel = useCallback(() => {
    switch (true) {
      case labelType === GROUP_OPTIONS.ASSIGNEE:
      case labelType === GROUP_OPTIONS.CREATOR:
      case !!(
        labelType?.includes(GROUP_OPTIONS.CUSTOM_FIELD_PREFIX) &&
        labelEntities?.[payload.value]?.avi &&
        labelEntities?.[payload.value]?.fullName
      ): {
        return (
          <AvatarTick
            payload={payload}
            user={labelEntities?.[payload?.value]}
            x={x}
            y={y}
          />
        );
      }
      default: {
        const displayValue = formatLabel(
          payload.value,
          labelType,
          labelEntities,
        );

        const truncatedValue =
          String(displayValue).length > 15
            ? `${String(displayValue).slice(0, 14)}…`
            : displayValue;

        return (
          <g transform={`translate(${x + (dx ?? 0)},${y + (dy ?? 0)})`}>
            <text
              x={0}
              y={0}
              dy={16}
              textAnchor="end"
              fill={CHART_COLORS.LABELS}
              transform="rotate(-45)"
              fontSize={12}
              fontWeight="normal"
            >
              {truncatedValue}
            </text>
          </g>
        );
      }
    }
  }, [dx, dy, labelEntities, labelType, payload, x, y]);

  return renderLabel();
};

export default CustomTick;
